// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Title_title__Vw8P3 {
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}
.Title_title__Vw8P3.Title_color-primary__0oKE2 {
  color: var(--primary-color);
}
.Title_title__Vw8P3.Title_color-font-primary__YWbDc {
  color: var(--font-primary-color);
}
.Title_title__Vw8P3.Title_color-font-secondary__HCs8b {
  color: var(--font-secondary-color);
}
.Title_title__Vw8P3.Title_color-grey-100__Sduc6 {
  color: #f4f5f7;
}
.Title_title__Vw8P3.Title_color-grey-200__qiymx {
  color: #dbdbdb;
}
.Title_title__Vw8P3.Title_color-grey-300__fOQyp {
  color: #acacac;
}
.Title_title__Vw8P3.Title_color-grey-400__yIhG6 {
  color: #838383;
}
.Title_title__Vw8P3.Title_color-secondary__FRI1Z {
  color: var(--secondary-color);
}
.Title_title__Vw8P3.Title_color-accent__a5r4X {
  color: var(--accent-color);
}
.Title_title__Vw8P3.Title_color-warning__ozJKe {
  color: orange;
}
.Title_title__Vw8P3.Title_color-error__LGYvH {
  color: #df6767;
}
.Title_title__Vw8P3.Title_color-white__nwS28 {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Title/Title.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,oBAAA;AADF;AAGE;EACE,2BCPM;ADMV;AAIE;EACE,gCCRW;ADMf;AAKE;EACE,kCCXa;ADQjB;AAME;EACE,cCbO;ADSX;AAOE;EACE,cChBO;ADWX;AAQE;EACE,cCnBO;ADaX;AASE;EACE,cCtBO;ADeX;AAUE;EACE,6BClCQ;AD0BZ;AAWE;EACE,0BCrCK;AD4BT;AAYE;EACE,aC/BM;ADqBV;AAaE;EACE,cClCI;ADuBR;AAcE;EACE,WCrCI;ADyBR","sourcesContent":["@import '@common/scss/_colors';\n\n.title {\n  margin-top: 0.2em;\n  margin-bottom: 0.2em;\n\n  &.color-primary {\n    color: $primary;\n  }\n\n  &.color-font-primary {\n    color: $font-primary;\n  }\n\n  &.color-font-secondary {\n    color: $font-secondary;\n  }\n\n  &.color-grey-100 {\n    color: $grey-100;\n  }\n\n  &.color-grey-200 {\n    color: $grey-200;\n  }\n\n  &.color-grey-300 {\n    color: $grey-300;\n  }\n\n  &.color-grey-400 {\n    color: $grey-400;\n  }\n\n  &.color-secondary {\n    color: $secondary;\n  }\n\n  &.color-accent {\n    color: $accent;\n  }\n\n  &.color-warning {\n    color: $warning;\n  }\n\n  &.color-error {\n    color: $error;\n  }\n\n  &.color-white {\n    color: $white;\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Title_title__Vw8P3`,
	"color-primary": `Title_color-primary__0oKE2`,
	"color-font-primary": `Title_color-font-primary__YWbDc`,
	"color-font-secondary": `Title_color-font-secondary__HCs8b`,
	"color-grey-100": `Title_color-grey-100__Sduc6`,
	"color-grey-200": `Title_color-grey-200__qiymx`,
	"color-grey-300": `Title_color-grey-300__fOQyp`,
	"color-grey-400": `Title_color-grey-400__yIhG6`,
	"color-secondary": `Title_color-secondary__FRI1Z`,
	"color-accent": `Title_color-accent__a5r4X`,
	"color-warning": `Title_color-warning__ozJKe`,
	"color-error": `Title_color-error__LGYvH`,
	"color-white": `Title_color-white__nwS28`
};
export default ___CSS_LOADER_EXPORT___;
